import React from 'react';
import { css } from '@linaria/core';
import { theme, brand } from '@terveystalo/design-system-theme';
import { classnames } from '../../utils';
import { getTypographyStyles } from './utils';
const hyphens = css `
  hyphens: manual;
`;
const defaultColor = css `
  color: ${brand.title.color.default.content};
`;
const variants = {
    l: css `
    font-family: ${brand.title.font.l.family};
    font-size: ${brand.title.font.l.size};
    line-height: ${brand.title.font.l.lineHeight};
    letter-spacing: ${brand.title.font.l.letterSpacing};
  `,
    xl: css `
    font-family: ${brand.title.font.xl.family};
    font-size: ${brand.title.font.xl.size};
    line-height: ${brand.title.font.xl.lineHeight};
    letter-spacing: ${brand.title.font.xl.letterSpacing};
  `,
    xxl: css `
    font-family: ${brand.title.font.xxl.family};
    font-size: ${brand.title.font.xxl.size};
    line-height: ${brand.title.font.xxl.lineHeight};
    letter-spacing: ${brand.title.font.xxl.letterSpacing};
  `,
    xxxl: css `
    font-family: ${brand.title.font.xxxl.family};
    font-size: ${brand.title.font.xxxl.size};
    line-height: ${brand.title.font.xxxl.lineHeight};
    letter-spacing: ${brand.title.font.xxl.letterSpacing};
  `,
};
const defaultWeights = {
    l: css `
    font-weight: ${brand.title.font.l.weight};
  `,
    xl: css `
    font-weight: ${brand.title.font.xl.weight};
  `,
    xxl: css `
    font-weight: ${brand.title.font.xxl.weight};
  `,
    xxxl: css `
    font-weight: ${brand.title.font.xxxl.weight};
  `,
};
const responsiveStyles = css `
  ${theme.media.viewport.notSmall} {
    font-size: ${brand.title.font.xl.size};
    line-height: ${brand.title.font.xl.lineHeight};
    letter-spacing: ${brand.title.font.xl.letterSpacing};
  }

  @media screen and (min-width: ${theme.media.breakpoint.m}) {
    font-size: ${brand.title.font.xxl.size};
    line-height: ${brand.title.font.xxl.lineHeight};
    letter-spacing: ${brand.title.font.xxl.letterSpacing};
  }
`;
/**
 * A "fixed" title component which can be used to render heading elements with correct styling applied.
 * The `as` prop with value from h1 to h6 is required but the `size` can be provided independently of the chosen
 * tag.
 *
 * As the text is rendered with potentially large font sizes, it is advisable to include soft hyphens
 * to allow the text to be broken more freely, allowing for better flow and layout.
 */
export function Title(props) {
    const { as: Component = 'h1', size, className, color, weight, ...rest } = props;
    const computedSize = size || 'l';
    const styles = getTypographyStyles({ color, weight, defaultColor, defaultWeight: defaultWeights[computedSize] });
    return (React.createElement(Component, { className: classnames(hyphens, size === undefined && responsiveStyles, variants[computedSize], ...styles.className, className), style: styles.style, ...rest }));
}


import "../../../css/atoms/Typography/Title.css";
